<div class="container container-fullsize">
    <div class="row">
        <div class="p-2 border">
            <div *ngIf="editandoEleicao == false" class="col-md-12 my-3">
                <h4>
                    <div (click)="voltar()" style="cursor: pointer;padding: 2px
                        20px 0 0;float: left;">
                        <i class="fas fa-arrow-left"></i>
                    </div>
                    Cadastro de eleição
                </h4>
                <hr>
            </div>
            <div *ngIf="editandoEleicao == true" class="col-md-12 mt-3">
                <h5>Edição das informações da eleição</h5>
                <hr>
            </div>
            <form role="form" [formGroup]="formGroup"
                (ngSubmit)="onSubmit(formGroup.value)">
                <div class="container">
                    <div *ngIf="editandoEleicao == true" class="row">
                        <div class="col-12 col-md-3">
                            <div class="row m-0">
                                <strong class="m-">Tipo de Registro Eleitores *</strong>
                                <select class="form-control"
                                    formControlName="acessoIntegracao">
                                    <option value="true">Integração</option>
                                    <option value="false">Importação</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12 col-md-2">
                            <div class="row m-0">
                                <strong class="m-">Enviar E-mail *</strong>
                                <select class="form-control"
                                    formControlName="enviaEmails">
                                    <option value="true">Sim</option>
                                    <option value="false">Não</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12 col-md-2">
                            <div class="row m-0">
                                <strong class="m-">Votos Rastreáveis *</strong>
                                <select class="form-control"
                                    formControlName="rastreabilidade"
                                    (change)="openFormModal(event)">
                                    <option value="true">Sim</option>
                                    <option value="false">Não</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12 col-md-3">
                            <div class="row m-0">
                                <strong class="m-">Campanha de Candidaturas*</strong>
                                <select class="form-control"
                                    formControlName="temCandidaturas"
                                   >
                                    <option value="true">Sim</option>
                                    <option value="false">Não</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12 col-md-2">
                            <div class="row m-0">
                                <strong class="m-">Tem Planos </strong>
                                <select class="form-control"
                                    formControlName="temPlanos">
                                    <option value="true">Sim</option>
                                    <option value="false">Não</option>
                                </select> 
                            </div>
                        </div>
                    </div>
                    <br><br>
                    <div *ngIf="editandoEleicao == true" class="row">
                        <div class="col-12 col-md-3">
                            <div class="row m-0">
                                <strong class="m-">Label para Autenticação 1 *</strong>
                                <input class="form-control ext-input p-8"
                                    placeholder="Digite a primeira label para
                                    autenticação"
                                    type="text" formControlName="labelAuth1">
                                <span class="alert alert-danger mr-2 ml-2 mt-n1
                                    p-1"
                                    *ngIf="!formGroup.get('labelAuth1').valid &&
                                    ( formGroup.get('labelAuth1').touched ||
                                    isSubmit )">
                                    <small>Label Autenticação 1 é obrigatório!</small>
                                </span>
                            </div>
                        </div>
                        <div class="col-12 col-md-3">
                            <div class="row m-0">
                                <strong class="m-">Label para Autenticação 2 *</strong>
                                <input class="form-control ext-input p-8"
                                    placeholder="Digite a segunda label para
                                    autenticação"
                                    type="text" formControlName="labelAuth2">
                                <span class="alert alert-danger mr-2 ml-2 mt-n1
                                    p-1"
                                    *ngIf="!formGroup.get('labelAuth2').valid &&
                                    ( formGroup.get('labelAuth2').touched ||
                                    isSubmit )">
                                    <small>Label Autenticação 2 é obrigatório!</small>
                                </span>
                            </div>
                        </div>
                        <div class="col-12 col-md-3">
                            <div class="row m-0">
                                <strong class="m-">Placeholder Input Login </strong>
                                <input class="form-control ext-input p-8"
                                    placeholder="Digite o placeholder do input de login."
                                    type="text" formControlName="placeHolderLogin">
                            </div>
                        </div>
                        <div class="col-12 col-md-3">
                            <div class="row m-0">
                                <strong class="m-">CNPJ </strong>
                                <input class="form-control ext-input p-8"
                                    placeholder="Digite o CNPJ."
                                    type="text" formControlName="cnpj">
                            </div>
                        </div>
                    </div>
                    <br><br>
                    <div *ngIf="editandoEleicao == true" class="row">

                        <div class="col-12 col-md-4">
                            <div class="row m-0">
                                <strong class="m-">Voto Nulo</strong>
                                <select class="form-control"
                                    formControlName="temVotoNulo"
                                   >
                                    <option value="true">Sim</option>
                                    <option value="false">Não</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="row m-0">
                                <strong class="m-">Voto Em Branco</strong>
                                <select class="form-control"
                                    formControlName="temVotoEmBranco"
                                   >
                                    <option value="true">Sim</option>
                                    <option value="false">Não</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="row m-0">
                                <strong class="m-">Cancelar Voto</strong>
                                <select class="form-control"
                                    formControlName="temCancelarVoto"
                                   >
                                    <option value="true">Sim</option>
                                    <option value="false">Não</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <br><br>
                    <div class="row">
                        <div class="col-12 col-md-4">
                            <div class="row m-0">
                                <strong>Título *</strong>
                            </div>
                            <div class="row m-0">
                                <input class="form-control ext-input p-8"
                                    placeholder="Informe o título da eleição"
                                    type="text" formControlName="titulo"
                                    (change)="gerarRota()">
                                <span class="alert alert-danger mr-2 ml-2 mt-n1
                                    p-1"
                                    *ngIf="!formGroup.get('titulo').valid && (
                                    formGroup.get('titulo').touched || isSubmit
                                    )">
                                    <small>Campo título é obrigatório!</small>
                                </span>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="row m-0">
                                <strong>Data Hora Início *</strong>
                            </div>
                            <div class="row m-0">
                                <input class="form-control ext-input p-8"
                                    type="datetime-local" min="2000-01-01T00:00"
                                    max="2100-12-31T00:00"
                                    placeholder="dd/MM/aaaa"
                                    formControlName="dataHoraInicio">
                                <span class="alert alert-danger mr-2 ml-2 mt-n1
                                    p-1"
                                    *ngIf="!formGroup.get('dataHoraInicio').valid
                                    && ( formGroup.get('dataHoraInicio').touched
                                    || isSubmit )">
                                    <small>Campo data e hora início é
                                        obrigatório!</small>
                                </span>
                                <span class="alert alert-danger mr-2 ml-2 mt-n1
                                    p-1"
                                    *ngIf="formGroup.get('dataHoraInicio').valid
                                    &&
                                    !this.validaData(formGroup.get('dataHoraInicio').value)
                                    && ( formGroup.get('dataHoraInicio').touched
                                    || isSubmit )">
                                    <small>A data precisa ser no futuro!</small>
                                </span>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="row m-0">
                                <strong>Data Hora Fim *</strong>
                            </div>
                            <div class="row m-0">
                                <input class="form-control ext-input p-8"
                                    type="datetime-local" min="2000-01-01T00:00"
                                    max="2100-12-31T00:00"
                                    placeholder="dd/MM/aaaa"
                                    formControlName="dataHoraFim">
                                <span class="alert alert-danger mr-2 ml-2 mt-n1
                                    p-1"
                                    *ngIf="!formGroup.get('dataHoraFim').valid
                                    && ( formGroup.get('dataHoraFim').touched ||
                                    isSubmit )">
                                    <small>Campo data e hora fim é obrigatório!</small>
                                </span>
                                <span class="alert alert-danger mr-2 ml-2 mt-n1
                                    p-1"
                                    *ngIf="formGroup.get('dataHoraFim').valid &&
                                    !this.validaData(formGroup.get('dataHoraFim').value)
                                    && !formGroup.get('dataHoraInicio').value
                                    && ( formGroup.get('dataHoraFim').touched ||
                                    isSubmit )">
                                    <small>A data precisa ser no futuro!</small>
                                </span>
                                <span class="alert alert-danger mr-2 ml-2 mt-n1
                                    p-1"
                                    *ngIf="formGroup.get('dataHoraFim').valid &&
                                    !this.validaData()
                                    && formGroup.get('dataHoraInicio').value
                                    && ( formGroup.get('dataHoraFim').touched ||
                                    isSubmit )">
                                    <small>A data fim precisa ser posterior ao
                                        inicio!</small>
                                </span>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-sm">
                            <strong>Mensagem *</strong>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm">
                            <angular-editor id="msg" formControlName="mensagem"
                                [config]="editorConfig"></angular-editor>
                            <span class="alert alert-danger m-2 p-1"
                                *ngIf="!formGroup.get('mensagem').valid && (
                                formGroup.get('mensagem').touched || isSubmit
                                )">
                                <small>Campo mensagem é obrigatório!</small>
                            </span>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-sm">
                            <strong>Instrução *</strong>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm">
                            <angular-editor id="instrucao"
                                formControlName="instrucao"
                                [config]="editorConfig"></angular-editor>
                            <span class="alert alert-danger m-2 p-1"
                                *ngIf="!formGroup.get('instrucao').valid && (
                                formGroup.get('instrucao').touched || isSubmit
                                )">
                                <small>Campo instrução é obrigatório!</small>
                            </span>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-sm">
                            <strong>Termo *</strong>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm">
                            <angular-editor id="termo" formControlName="termo"
                                [config]="editorConfig"></angular-editor>
                            <span class="alert alert-danger m-2 p-1"
                                *ngIf="!formGroup.get('termo').valid && (
                                formGroup.get('termo').touched || isSubmit )">
                                <small>Campo termo é obrigatório!</small>
                            </span>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-sm">
                            <strong>Logo</strong>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm">

                            <div class="image-upload d-flex flex-row
                                align-items-center">
                                <div *ngIf="imageSrc" class="p-1 mr-3"
                                    style="border:solid 1px #d1d1d1;
                                    border-radius: 3px">
                                    <img [src]="imageSrc"
                                        style="max-width:160px;height: auto"/>
                                </div>
                                <input class="form-control ext-input p-8"
                                    name="imageUrl" type="file" accept="image/*"
                                    (change)="handleInputChange($event)" />
                            </div>
                            <div style="min-width: 150px;font-size:75%">Resolução 390 x 138 / Tipo PNG.</div>
                            <!-- <input placeholder="Logo da eleição" 
                        type="file" (change)="changeListener($event)" formControlName="logo"> -->
                        </div>
                    </div>
                </div>
                <br>
                <div class="container">
                    <div class="row justify-content-center m-0">
                        <div class="col" class="alert alert-dark" role="alert">
                            <p class="mb-0"><strong>Link de acesso da eleição:
                                </strong> {{link}}/{{rota}}</p>
                        </div>
                    </div>
                </div>
                <div>
                    <table class="row justify-content-center">
                        <tr>
                            <td>
                                <div style="min-width: 150px;font-size:95%">
                                    <button (click)="back()" class="btn
                                        btn-danger btn-primary btn-block"
                                        [disabled]="btOff"> CANCELAR </button>
                                </div>
                            </td>
                            <td></td>
                            <td></td>
                            <td>
                                <div style="min-width: 150px;font-size:95%">
                                    <button type="submit" class="btn btn-success
                                        btn btn-primary btn-block"
                                        [disabled]="!formGroup.valid
                                        || validaData() == false"
                                        [disabled]="btOff">SALVAR</button>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </form>
            <br>
        </div>
    </div>
    <div class="modal fade" id="myModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title text-center" id="exampleModalLabel">Atenção!</h2>
                    <button type="button"  class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <h4 *ngIf="formGroup.get('rastreabilidade').value =='true'">Essa configuração permite que nesta eleição os votos do eleitores sejam rastreáveis. Tem certeza que deseja habilitar essa funcionalidade?</h4>
                    <h4 *ngIf="formGroup.get('rastreabilidade').value =='false'">Essa configuração permite que nesta eleição os votos do eleitores sejam rastreáveis. Tem certeza que deseja desabilitar essa funcionalidade?</h4>
                </div>
                <div class="modal-footer text-center" >
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="rastreabilidadeHabilitada()">
                      Sim
                    </button>
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="limpaRastreabilidade()">
                        Não
                     </button>
                </div>
            </div>
        </div>
    </div>
</div>
